import BrandLogo from "@/components/BrandLogo";
import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import api, { apiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useBranding } from "@/context/BrandingContext";

export default function ForgotPassword() {
  const { applyNeutral, exitNeutral } = useBranding();
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => { applyNeutral(); return () => exitNeutral(); }, [applyNeutral, exitNeutral]);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    try {
      await api.post("/auth/forgot-password", { email });
      setDone(true);
    } catch (err) {
      setError(apiError(err.response?.data?.detail) || err.message);
    }
  };

  return (
    <div className="min-h-screen flex items-center justify-center bg-dd-night p-6">
      <div className="w-full max-w-sm bg-white rounded-xl p-8">
        <div className="mb-6"><BrandLogo className="h-12" /></div>
        <h2 className="text-2xl font-bold text-dd-blue">Mot de passe oublié</h2>
        {done ? (
          <p className="mt-4 text-sm text-dd-night" data-testid="forgot-done">
            Si cette adresse est enregistrée, un lien de réinitialisation vous a été envoyé.
          </p>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-4" data-testid="forgot-form">
            <div>
              <Label className="text-dd-night">Email</Label>
              <Input type="email" value={email} onChange={(e) => setEmail(e.target.value)}
                required className="mt-1 h-11" data-testid="forgot-email" />
            </div>
            {error && <div className="text-sm text-destructive">{error}</div>}
            <Button type="submit" className="w-full h-11 bg-dd-blue hover:bg-dd-night text-white" data-testid="forgot-submit">
              Envoyer le lien
            </Button>
          </form>
        )}
        <Link to="/login" className="mt-6 block text-sm text-dd-blue hover:underline">Retour à la connexion</Link>
      </div>
    </div>
  );
}
